document.addEventListener("DOMContentLoaded", function () {
  // *.*.*.*.*.*.*.*.*.*.* START OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelectorAll(".album_list")) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true,
      });
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF light Gallery *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* Responsive table *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement("div");
      parentTable.classList.add("table_res");
      if (table.parentNode) {
        table.parentNode.replaceChild(parentTable, table);
        parentTable.appendChild(table);
      }
    });
  }

  // *.*.*.*.*.*.*.*.*.*.* START OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "flex";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 1500);
      });
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF tiny url *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  function setupTabs(tabButtons, contentBoxes, container) {
    const tabs = Array.from(container.querySelectorAll(tabButtons));
    const contents = Array.from(container.querySelectorAll(contentBoxes));

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add("active");
            contents[i].classList.add("visible");
          } else {
            tab.classList.remove("active");
            contents[i].classList.remove("visible");
          }
        });
      });
    });
  }

  // Setting up all the main tab containers
  document.querySelectorAll(".primary_multi_tab").forEach((container) => {
    setupTabs(".tabs_title li", ".tab_content", container);
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF TABs *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* START OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // Main menu toggle
  const mainMenu = document.querySelector(".top_nav");
  const menuToggleButton = document.querySelector(".menu_btn_cnt");

  if (mainMenu && menuToggleButton) {
    menuToggleButton.addEventListener("click", () => {
      setTimeout(() => {
        mainMenu.classList.toggle("slide_down");
        menuToggleButton.classList.toggle("close_open");
      }, 10);
    });
  }
  // ----- SUB_MENU -----

  document.querySelectorAll(".sub_menu_btn").forEach((subMenuButton) => {
    subMenuButton.addEventListener("click", () => {
      const subMenu = subMenuButton.nextElementSibling;
      if (subMenu && subMenu.classList.contains("sub_menu")) {
        subMenu.classList.toggle("slide_down");
        subMenuButton.classList.toggle("top");
      }
    });
  });

  // ----- END OF SUB_MENU -----
    // fixed menu

  const headerTop = document.querySelector(".header_top");
  const headerMenu = document.querySelector(".header_menu");
  const headerMobile = document.querySelector(".main_header_inner");
  const body = document.querySelector("body");
  const headerNav = document.querySelector(".main_wrapper .top_nav");
  const mainSliderWrapper = document.querySelector(".main_slider_wrapper");

  const headerHeight = headerMenu.offsetHeight;
  const updateDesktopHeaderMode = () => {
    if (!mainSliderWrapper || window.innerWidth < 1201) {
      headerMenu.classList.remove("after-slider-light");
      return;
    }

    headerMenu.classList.toggle("after-slider-light", mainSliderWrapper.getBoundingClientRect().bottom <= 0);
  };

  window.addEventListener("scroll", function () {
    if (window.scrollY >= headerTop.offsetHeight) {
      headerMenu.classList.add("fixed-menu");
      body.style.paddingTop = `${headerHeight}px`;
    } else {
      headerMenu.classList.remove("fixed-menu");
      body.style.paddingTop = "0";
    }
    updateDesktopHeaderMode();
  });
  window.addEventListener("resize", updateDesktopHeaderMode);
  updateDesktopHeaderMode();
  if (window.innerWidth <= 1100) {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= headerMobile.offsetHeight) {
        headerMobile.classList.add("fixed-menu");
      } else {
        headerMobile.classList.remove("fixed-menu");
      }
    });
    headerNav.style.top = "64px";
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* END OF main menu *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // ---- START OF COMMENT NEWS AJAX ----
  if (document.getElementById("comment_list_ajax")) {
    const commentList = document.getElementById("comment_list_ajax");
    const loadMoreBtn = document.getElementById("load_more_comment");
    let currentPage = 1;
    // Initialize limit comment number
    const limitPage = 5;

    if (news_comment < limitPage) loadMoreBtn.remove();

    const loadMoreComments = () => {
      fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
        .then((response) => response.json())
        .then((data) => {
          if (!data || data.length < limitPage) loadMoreBtn.style.display = "none";
          if (data) {
            data.forEach((comment) => {
              const renderChildren = (children) =>
                children
                  ? `<ul>${children
                      .map(
                        (child) => `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">
                  ${child.name || window.i18n.commentUnknown}
                                      <span class="comment_published">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M2.3916 11.459C2.3916 8.15915 2.3916 6.50924 3.41673 5.48411C4.44185 4.45898 6.09177 4.45898 9.3916 4.45898H12.8916C16.1914 4.45898 17.8413 4.45898 18.8665 5.48411C19.8916 6.50924 19.8916 8.15915 19.8916 11.459V13.209C19.8916 16.5088 19.8916 18.1587 18.8665 19.1839C17.8413 20.209 16.1914 20.209 12.8916 20.209H9.3916C6.09177 20.209 4.44185 20.209 3.41673 19.1839C2.3916 18.1587 2.3916 16.5088 2.3916 13.209V11.459Z" stroke="#C3C3C3" stroke-width="1.3125"/>
  <path d="M6.7666 4.45898V3.14648" stroke="#C3C3C3" stroke-width="1.3125" stroke-linecap="round"/>
  <path d="M15.5166 4.45898V3.14648" stroke="#C3C3C3" stroke-width="1.3125" stroke-linecap="round"/>
  <path d="M2.8291 8.83398H19.4541" stroke="#FFE500" stroke-width="1.3125" stroke-linecap="round"/>
</svg>
<time datetime="${child.creation}">${child.date}</time>
                    </span>
                  </div>
                  <div class="comment_reply">

                                      <button aria-label="like" onclick="Rate.plus(${child.master_id})" class="like">
                      <span id="rateplus${child.master_id}">${child.plus || 0}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M12.3856 7.9445H17.0985C17.9453 7.9445 18.7449 8.33465 19.2661 9.00212C19.7872 9.66959 19.9718 10.5399 19.7664 11.3615L18.3277 17.1162C18.0129 18.3754 16.8815 19.2587 15.5836 19.2587H2.56418C1.7831 19.2587 1.1499 18.6256 1.1499 17.8445V9.35878C1.1499 8.5777 1.7831 7.9445 2.56418 7.9445H6.09989V7.94159L7.93498 2.51366C8.04204 2.197 8.27081 1.93602 8.57072 1.7884C8.87063 1.64079 9.21698 1.61869 9.53322 1.727L10.261 1.97626C11.5319 2.41149 12.3856 3.60627 12.3856 4.94955V7.94159" stroke="#D7D7D7" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.10029 19.2559V7.94409" stroke="#D7D7D7" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>

                    <button aria-label="dislike" onclick="Rate.minus(${child.master_id})" class="dislike">
                      <span id="rateminus${child.master_id}">${child.minus || 0}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
  <path d="M12.9354 12.973L17.6483 12.973C18.4951 12.973 19.2947 12.5828 19.8159 11.9154C20.337 11.2479 20.5216 10.3776 20.3162 9.55602L18.8775 3.80127C18.5627 2.54209 17.4313 1.65873 16.1334 1.65873L3.11398 1.65873C2.3329 1.65873 1.69971 2.29193 1.69971 3.07301L1.69971 11.5587C1.69971 12.3398 2.3329 12.973 3.11398 12.973L6.64969 12.973L6.64969 12.9759L8.48478 18.4038C8.59185 18.7205 8.82062 18.9815 9.12053 19.1291C9.42044 19.2767 9.76679 19.2988 10.083 19.1905L10.8108 18.9412C12.0817 18.506 12.9354 17.3112 12.9354 15.9679L12.9354 12.9759" stroke="#D7D7D7" stroke-width="1.81499" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.6501 1.66162L6.6501 12.9734" stroke="#D7D7D7" stroke-width="1.81499" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      </button>



                  
                    </div>
                </div>
                <div class="matn_comment">
                  <p>${child.message}</p>
                </div>
              </li>`
                      )
                      .join("")}</ul>`
                  : "";

              commentList.innerHTML += `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">
                  ${comment.name || window.i18n.commentUnknown}
                  <span class="comment_published">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M2.3916 11.459C2.3916 8.15915 2.3916 6.50924 3.41673 5.48411C4.44185 4.45898 6.09177 4.45898 9.3916 4.45898H12.8916C16.1914 4.45898 17.8413 4.45898 18.8665 5.48411C19.8916 6.50924 19.8916 8.15915 19.8916 11.459V13.209C19.8916 16.5088 19.8916 18.1587 18.8665 19.1839C17.8413 20.209 16.1914 20.209 12.8916 20.209H9.3916C6.09177 20.209 4.44185 20.209 3.41673 19.1839C2.3916 18.1587 2.3916 16.5088 2.3916 13.209V11.459Z" stroke="#C3C3C3" stroke-width="1.3125"/>
  <path d="M6.7666 4.45898V3.14648" stroke="#C3C3C3" stroke-width="1.3125" stroke-linecap="round"/>
  <path d="M15.5166 4.45898V3.14648" stroke="#C3C3C3" stroke-width="1.3125" stroke-linecap="round"/>
  <path d="M2.8291 8.83398H19.4541" stroke="#FFE500" stroke-width="1.3125" stroke-linecap="round"/>
</svg>



<time datetime="${comment.creation}">${comment.date}</time>
                    </span>
                  </div>
                  <div class="comment_reply">
                    
                    <button aria-label="like" onclick="Rate.plus(${comment.master_id})" class="like">
                      <span id="rateplus${comment.master_id}">${comment.plus || 0}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
  <path d="M12.3856 7.9445H17.0985C17.9453 7.9445 18.7449 8.33465 19.2661 9.00212C19.7872 9.66959 19.9718 10.5399 19.7664 11.3615L18.3277 17.1162C18.0129 18.3754 16.8815 19.2587 15.5836 19.2587H2.56418C1.7831 19.2587 1.1499 18.6256 1.1499 17.8445V9.35878C1.1499 8.5777 1.7831 7.9445 2.56418 7.9445H6.09989V7.94159L7.93498 2.51366C8.04204 2.197 8.27081 1.93602 8.57072 1.7884C8.87063 1.64079 9.21698 1.61869 9.53322 1.727L10.261 1.97626C11.5319 2.41149 12.3856 3.60627 12.3856 4.94955V7.94159" stroke="#D7D7D7" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.10029 19.2559V7.94409" stroke="#D7D7D7" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</button>
                    <button aria-label="dislike" onclick="Rate.minus(${comment.master_id})" class="dislike">
                      <span id="rateminus${comment.master_id}">${comment.minus || 0}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
  <path d="M12.9354 12.973L17.6483 12.973C18.4951 12.973 19.2947 12.5828 19.8159 11.9154C20.337 11.2479 20.5216 10.3776 20.3162 9.55602L18.8775 3.80127C18.5627 2.54209 17.4313 1.65873 16.1334 1.65873L3.11398 1.65873C2.3329 1.65873 1.69971 2.29193 1.69971 3.07301L1.69971 11.5587C1.69971 12.3398 2.3329 12.973 3.11398 12.973L6.64969 12.973L6.64969 12.9759L8.48478 18.4038C8.59185 18.7205 8.82062 18.9815 9.12053 19.1291C9.42044 19.2767 9.76679 19.2988 10.083 19.1905L10.8108 18.9412C12.0817 18.506 12.9354 17.3112 12.9354 15.9679L12.9354 12.9759" stroke="#D7D7D7" stroke-width="1.81499" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.6501 1.66162L6.6501 12.9734" stroke="#D7D7D7" stroke-width="1.81499" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      </button>
                    <button aria-label="replay" onclick="setCommentParentId(${comment.id})" class="reply">${window.i18n.commentReply} 
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
<path d="M16.334 6.85888H16.2504C12.605 6.85888 9.65039 9.81347 9.65039 13.4589V15.0198V20.0588" stroke="#BEBEBE" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.3384 6.85894H21.7504" stroke="#BEBEBE" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.9501 16.7588L9.65009 20.0588L6.3501 16.7588" stroke="#BEBEBE" stroke-width="1.64999" stroke-linecap="round" stroke-linejoin="round"/>
</svg></button>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${comment.message}</p>
                  ${comment.children === null || comment.children.length === 0 ? "" : renderChildren(comment.children)}
                </div>
              </li>`;
            });
            currentPage++;
          }
        })
        .catch((error) => console.error(error));
    };

    loadMoreComments();
    loadMoreBtn.addEventListener("click", loadMoreComments);
  }

  // ---- END OF COMMENT NEWS AJAX ----
  // *.*.*.*.*.*.*.*.*.*.* search input mobile *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  let icon_search = document.querySelector(".mobile_search");
  let icons_search = icon_search.querySelector(".search_icon");
  let icons_close = icon_search.querySelector(".close_icon");
  let search_container = document.querySelector(".search_container");

  icon_search.addEventListener("click", () => {
    search_container.classList.toggle("active");
    if (icons_search.classList.contains("active")) {
      icons_search.classList.remove("active");
      icons_close.classList.add("active");
    } else {
      icons_search.classList.add("active");
      icons_close.classList.remove("active");
    }
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF search input mobile *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* BACK TO TOP BUTTON *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  let bottonUp = document.querySelector(".botton_up");
  bottonUp.addEventListener("click", function () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  });

  // *.*.*.*.*.*.*.*.*.*.* END OF BACK TO TOP BUTTON *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

  // *.*.*.*.*.*.*.*.*.*.* Paragraph counter *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  var countP = document.querySelectorAll("#echo_details p:not(table p, blockquote p)");

  function insertBefore(newNode, dist) {
    dist.parentNode.insertBefore(newNode, dist);
  }

  //INLINE ZXC ADV PLACE  // After paragraph 1th
  if (document.getElementById("anchor_list")) {
    if (countP.length > 1) {
      var tableOfC = document.getElementById("anchor_list");
      insertBefore(tableOfC, countP[0].nextSibling);
    } else {
      countP[0].appendChild(tableOfC);
    }
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF Paragraph counter *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* video thumbnail slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.querySelector("#main-slider-news")) {
    let mainSlider = new Splide("#main-slider-news", {
      heightRatio: 0.5,
      pagination: false,
      arrows: false,
      direction: "rtl",
    });
    let thumbnailSlider = new Splide("#thumbnail-slider-news", {
      fixedWidth: 245,
      fixedHeight: 155,
      isNavigation: true,
      gap: 8,
      focus: "right",
      pagination: false,
      cover: true,
      arrows: false,
      direction: "rtl",
      rewind: true,
    });
    // progressBar
    mainSlider.sync(thumbnailSlider);
    mainSlider.mount();
    thumbnailSlider.mount();
    let progressBar = document.createElement("div");
    progressBar.classList.add("splide-progress");
    progressBar.innerHTML = '<div class="splide-progress-bar"></div>';
    document.querySelector("#main-slider-news").appendChild(progressBar);
    function updateProgress() {
      let bar = document.querySelector(".splide-progress-bar");
      let progress = (mainSlider.index + 1) / mainSlider.length;
      bar.style.width = progress * 100 + "%";
    }
    updateProgress();
    mainSlider.on("mounted move", updateProgress);
  }

  // *.*.*.*.*.*.*.*.*.*.* END OF video thumbnail slider *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* anchor_list more button *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const more_btn = document.querySelector(".more_anchor");
  if (more_btn) {
    more_btn.addEventListener("click", function () {
      if (more_btn.children.length > 0) {
        more_btn.children[0].classList.toggle("active");
      }
      if (more_btn.parentElement && more_btn.parentElement.nextElementSibling) {
        more_btn.parentElement.nextElementSibling.classList.toggle("invisible");
      }
    });
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF anchor_list more button *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* emergency news *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.getElementById("emergency_news")) {
    const splide = new Splide("#emergency_news", {
      type: "loop",
      perPage: 1,
      pagination: false,
      gap: "1em",
      focus: "center",
      drag: false,
      wheel: false,
      autoplay: true,
      interval: 5000,
      flickMaxPages: 1,
      updateOnMove: true,
      direction: "rtl",
      arrows: false,
      pauseOnHover: false,
    }).mount();
  }
  // close
  const emergencyNewsWrapper = document.querySelector(".emergency_news_wrapper");
  const closeNewsButtons = document.querySelectorAll(".close_news");

  closeNewsButtons.forEach((button) => {
    button.addEventListener("click", () => {
      emergencyNewsWrapper.classList.add("deactive");
    });
  });

  // *.*.*.*.*.*.*.*.*.*.* END OF emergency news *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  // *.*.*.*.*.*.*.*.*.*.* sticky sidebar *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*


const sticky = document.querySelector(".sticky_wrapper");
const placeholder = document.querySelector(".sticky_placeholder");
const container = document.querySelector(".news_row_inner");
const sidebar = document.querySelector(".news_row_left");

if (!sticky || !placeholder || !container || !sidebar) return;

const topSpace = 80;

function updateSticky() {
    if (window.innerWidth < 1000) {
        sticky.classList.remove("is-fixed");
        sticky.style.top = "";
        sticky.style.left = "";
        sticky.style.width = "";
        placeholder.style.height = "";
        return;
    }

    const scrollTop = window.pageYOffset;
    const stickyHeight = sticky.offsetHeight;
    const sidebarRect = sidebar.getBoundingClientRect();
    const placeholderTop = placeholder.getBoundingClientRect().top + scrollTop;
    const containerTop = container.getBoundingClientRect().top + scrollTop;
    const containerBottom = containerTop + container.offsetHeight;
    const activatePoint = placeholderTop - topSpace;
    const stopPoint = containerBottom - stickyHeight - topSpace;

    placeholder.style.height = stickyHeight + "px";

    sticky.classList.remove("is-fixed");
    sticky.style.top = "";
    sticky.style.left = "";
    sticky.style.width = "";

    if (scrollTop < activatePoint) return;

    if (scrollTop >= activatePoint && scrollTop < stopPoint) {
        sticky.classList.add("is-fixed");
        sticky.style.top = topSpace + "px";
        sticky.style.left = sidebarRect.left + "px";
        sticky.style.width = sidebarRect.width + "px";
        return;
    }

    const frozenTop = stopPoint - scrollTop + topSpace;
    sticky.classList.add("is-fixed");
    sticky.style.top = frozenTop + "px";
    sticky.style.left = sidebarRect.left + "px";
    sticky.style.width = sidebarRect.width + "px";
}

window.addEventListener("scroll", updateSticky);
window.addEventListener("resize", updateSticky);
updateSticky();

  // *.*.*.*.*.*.*.*.*.*.* END OF sticky sidebar *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

    // *.*.*.*.*.*.*.*.*.*.* dark/light mood *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  const lightBtn = document.querySelector(".theme-switcher-light");
  const darkBtn = document.querySelector(".theme-switcher-dark");
  const savedTheme = localStorage.getItem("theme");
  const setThemeButtonHidden = (button, isHidden) => {
    if (!button) {
      return;
    }

    button.hidden = isHidden;
    button.style.display = isHidden ? "none" : "";
  };
  const updateThemeSwitcher = () => {
    const isLight = document.body.classList.contains("light");

    setThemeButtonHidden(darkBtn, !isLight);
    setThemeButtonHidden(lightBtn, isLight);
  };

  if (savedTheme === "light") {
    document.body.classList.add("light");
  }

  updateThemeSwitcher();

  // Light mode
  lightBtn?.addEventListener("click", () => {
    document.body.classList.add("light");
    localStorage.setItem("theme", "light");
    updateThemeSwitcher();
  });

  // Dark mode
  darkBtn?.addEventListener("click", () => {
    document.body.classList.remove("light");
    localStorage.setItem("theme", "dark");
    updateThemeSwitcher();
  });
  // *.*.*.*.*.*.*.*.*.*.* END OF dark/light mood *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*

// ---- ADV PLACE INLINE ----

var containerP = document.getElementById("echo_details");
var adv = document.getElementById("first_inline_zxc");

if (!containerP || !adv) return;

// p و table هر دو یک بلاک حساب می‌شوند (p داخل table/blockquote و table تودرتو حساب نمی‌شوند)
var blocks = containerP.querySelectorAll(
    "p:not(table p, blockquote p), table:not(table table)"
);

var target = blocks.length > 1 ? blocks[1] : blocks[0];

if (target) {
    // اگر بلاک داخل wrapper است (مثل figure یا div دور table) بعد از خود wrapper قرار بگیرد
    while (target.parentElement && target.parentElement !== containerP) {
        target = target.parentElement;
    }
    target.after(adv);
    adv.style.display = "block";
} else {
    adv.style.display = "none";
}

// ---- END OF ADV PLACE INLINE ----

});
